export enum Features {
    IntroductoryScreens = 1,
    Planning = 2,
    Analytics = 3,
    ClientDashboard = 4,
    Contracts = 5
}